var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTtSettings = function SvgTtSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      width: "inherit",
      height: "inherit"
    },
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.594 11.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.214 1.281c.062.374.312.686.644.87q.11.06.22.127c.325.196.72.257 1.076.124l1.216-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.259 1.431l-1.004.827c-.293.24-.438.613-.43.992a7 7 0 0 1 0 .254c-.008.38.137.751.43.992l1.004.827c.425.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.216-.456c-.356-.133-.751-.072-1.076.124a7 7 0 0 1-.22.128c-.332.183-.582.495-.644.869l-.214 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a7 7 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.296-2.247a1.125 1.125 0 0 1 .259-1.431l1.004-.827c.293-.24.438-.613.43-.992a7 7 0 0 1 0-.254c.008-.38-.137-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124q.11-.066.22-.128c.332-.183.582-.495.644-.869z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 20a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
  }))));
};
export { SvgTtSettings as ReactComponent };
export default __webpack_public_path__ + "e8c79d82272531c16e0c5a407f4fd0f4.svg";